export default "__VITE_ASSET__2804fbaa__"